export default __webpack_public_path__ + "static/media/headphone.7a89db81.svg";